export default "__VITE_ASSET__BNTkTKAD__"